import Vue from 'vue'
import i18n from '@/lang'
import moment from 'moment'

Vue.filter('formatDate', function (value) {
  if (!value) return ''
  var dateFormat = i18n.t('format.date')
  return moment(value).format(dateFormat);
})

Vue.filter('showDateForm', function (value) {
  if (!value) return '';
  var dateFormat = i18n.t('format.show_date_form');
  return moment(value).format(dateFormat);
})

Vue.filter('saveDateForm', function (value) {
  if (!value) return '';
  var dateFormat = i18n.t('format.save_date_form');
  var dateOrigin = i18n.t('format.show_date_form');
  return moment(value, dateOrigin).format(dateFormat);
})

Vue.filter('showTimeForm', function (value) {
  if (!value) return '';
  var timeFormat = i18n.t('format.time_form');
  return moment(value).format(timeFormat);
})

Vue.filter('formatTime', function (value) {
  if (!value) return ''
  var dateFormat = i18n.t('format.time')
  return moment(value).format(dateFormat);
})

Vue.filter('formatDateAtTime', function (value) {
  if (!value) return ''
  var dateAtTimeFormat = i18n.t('format.date_at_time')
  return moment(value).format(dateAtTimeFormat)
})

Vue.filter('formatDateAtTimeList', function (value) {
  if (!value) return ''
  var currentDate = new Date()
  var tomorrowDate = new Date()
  tomorrowDate.setDate(tomorrowDate.getDate() + 1)

  var dateAtTimeFormat = i18n.t('format.date_at_time')
  var dateFormat = i18n.t('format.date')

  if (moment(value).format(dateFormat) == moment(currentDate).format(dateFormat)) {
    return moment(value).format(i18n.t('format.today_at_time'))
  } else if (moment(value).format(dateFormat) == moment(tomorrowDate).format(dateFormat)) {
    return moment(value).format(i18n.t('format.tomorrow_at_time'))
  }
  return moment(value).format(dateAtTimeFormat)
})

Vue.filter('formatDateMonthAtTime', function (value) {
  if (!value) return ''
  var dateMonthAtTimeFormat = i18n.t('format.date_month_and_time')
  return moment(value).format(dateMonthAtTimeFormat)
})



// WEBPACK FOOTER //
// ./src/filters/formatDateTime.js